"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fade = () => {
    const fadeElems = document.querySelectorAll('.fade___in');
    const fadeIn = () => {
        const scroll = window.scrollY;
        const windowHeight = window.innerHeight;
        fadeElems.forEach((fadeElem) => {
            const target = fadeElem;
            const targetPos = target.getBoundingClientRect().top + scroll;
            if (scroll > targetPos - windowHeight * 0.75) {
                target.classList.add('is_viewed');
            }
        });
    };
    window.addEventListener('scroll', fadeIn);
    fadeIn(); // 初回表示
};
exports.default = fade;
